import { Injectable } from '@angular/core';
import { Subject, Observable } from 'rxjs';
import { Action } from '@models/action/action';

@Injectable({
    providedIn: 'root'
})
export class ActionService {
    private action = new Subject<Action>();

    get(): Observable<Action> {
        return this.action.asObservable();
    }

    set(action: Action): void {
        this.action.next(action);
    }
}
